var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;



//////////////////
// WEBPACK FOOTER
// ./~/_lodash@4.17.10@lodash/_nativeCreate.js
// module id = 25
// module chunks = 0